// extracted by mini-css-extract-plugin
export default {"nav":"Layout_nav__IZhoc","mainWithBottomNav":"Layout_mainWithBottomNav__DBQr1"};